import {theme, Tooltip } from "antd";
import React from "react";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_EMPLOYEE, URL_USER } from "../../constants/urls";
import { 
  EditOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import { DELETE } from "../../frameworks/HttpClient";
import EmployeeModal from "../../components/user/EmployeeModal";
import ErrorMessages from "../../common/ErrorMessages";

export default function EmployeeView() {
  const tableRef = React.useRef(null);
  const [ target, setTarget ] = React.useState(null);
  const [ errorMessages, setErrorMessages] = React.useState(null);
  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleDelete = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_EMPLOYEE.EMPLOYEE}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const columns = [
    {
      title: "Action",
      dataIndex: "id",
      width: 170,
      key: "id",
      render: (_, record) =>
      <center>
        <div onClick={(e) => e.stopPropagation()}>
          <Tooltip triger="hover" title="แก้ไขข้อมูล">
            <ColorButton
              type="primary"
              override={colorWarning}
              style={{ margin: 5 }}
              icon={<EditOutlined />}
              onClick={() => setTarget(record)}
            />
          </Tooltip>
          <CustomDeleteConfirmButton
            tooltips={"ลบผู้ใช้งาน"}
            title={`ลบผู้ใช้งาน - ${record.name}`}
            content={"คุณต้องการลบผู้ใช้งานใช่หรือไม่"}
            onOk={ async() => {
              await handleDelete(record.id)
              refreshData();
            }}
            onConfirm={() => refreshData()}
          />
        </div>
      </center>
    },
    {
      title: "ชื่อ",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Pin",
      dataIndex: "pin",
      key: "pin",
    },
  ]

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        style={{ marginBottom: 20, float: 'right' }}
        icon={<PlusCircleOutlined />}
        onClick={() => setTarget('add')}
      >
        เพิ่ม Pin  
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={`${URL_EMPLOYEE.EMPLOYEE}`}
        ref={tableRef}
      />
      
      <EmployeeModal  
        open={target ? true : false}
        onClose={() => {
          setTarget(null)
        }}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
        target={target}
      />
    </div>
  )
}